// import appSettings from '../appSettings';
// import AppConsts from '../lib/appconst';

export const newGuid = '00000000-0000-0000-0000-000000000000';
export const getNewDate = () => {
  const date = new Date();
  date.setHours(12, 0, 0, 0);

  return date;
};

export const servicePath = window.config.apiUrl; // appSettings.apiUrl;
export const fileUploadPath = `${window.config.apiUrl}api/FileUpload/UploadFile`;
export const getImagePath = `${window.config.apiUrl}api/Images/GetById?id=`;
export const getImagePathByTenant = `${window.config.apiUrl}api/Images/GetByTenantId?id=`;
export const isDarkSwitchActive = true;
